/** A serial title write lane. Failed drafts survive route changes in this tab. */
export class PageTitleDraft {
  private state: { title: string; status: 'saved' | 'pending' | 'saving' | 'error'; error: string | null };
  private timer: ReturnType<typeof setTimeout> | null = null;
  private running: Promise<void> | null = null;
  private version = 0;
  private savedVersion = 0;
  private listeners = new Set<() => void>();

  constructor(title: string, private save: (title: string) => Promise<void>) {
    this.state = { title, status: 'saved', error: null };
  }
  snapshot = () => this.state;
  subscribe = (listener: () => void) => { this.listeners.add(listener); return () => { this.listeners.delete(listener); }; };
  setWriter(save: (title: string) => Promise<void>): void { this.save = save; }
  private publish(update: Partial<typeof this.state>): void {
    this.state = { ...this.state, ...update };
    for (const listener of this.listeners) listener();
  }
  remote(title: string): void {
    if (this.state.status === 'saved' && title !== this.state.title) this.publish({ title });
  }
  rename(title: string): void {
    this.version++;
    this.publish({ title, status: 'pending', error: null });
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => { void this.flush(); }, 400);
  }
  flush(): Promise<void> {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
    if (this.running) return this.running;
    this.running = this.write().finally(() => { this.running = null; });
    return this.running;
  }
  private async write(): Promise<void> {
    while (this.savedVersion !== this.version) {
      const version = this.version;
      const title = this.state.title;
      this.publish({ status: 'saving', error: null });
      try {
        await this.save(title);
        this.savedVersion = version;
      } catch (cause) {
        this.publish({ status: 'error', error: cause instanceof Error ? cause.message : 'The title could not be saved' });
        return;
      }
    }
    this.publish({ status: 'saved', error: null });
  }
}
